import React, { useState } from "react";
import {
  FaPlane,
  FaClock,
  FaWhatsapp,
  FaAward,
  FaBriefcase,
  FaArrowRight,
  FaPlayCircle,
  FaChevronDown,
  FaTimes,
  FaCheckCircle,
  FaGlobeAmericas,
  FaUserTie,
  FaShieldAlt,
} from "react-icons/fa";

import chef from "../components/assets/images/Img-Carousel/Aviacion1.jpg";
import chef2 from "../components/assets/images/ceva-piura-log.png";
import TeamSections from "./profav";

/* ==========================
   COLORES CEVATUR
========================== */
const COLORS = {
  red: "#D71920",
  blue: "#004AAD",
  yellow: "#F4C400",
};

const AviacionComercialCevatur = () => {
  const [openFaq, setOpenFaq] = useState(0);
  const [openVideo, setOpenVideo] = useState(false);

  const faqs = [
    {
      q: "¿Cuánto dura la carrera?",
      a: "La carrera tiene una duración de 24 meses con formación integral teórica y práctica.",
    },
    {
      q: "¿Qué puestos puedo ocupar?",
      a: "Podrás trabajar en counter, tripulación de cabina, atención aeroportuaria y operaciones.",
    },
    {
      q: "¿Incluye simulación real?",
      a: "Sí. Contamos con entrenamiento aplicado y simulador de vuelo.",
    },
  ];

  return (
    <div className="bg-slate-50 text-slate-800" id="bartender">

      {/* HERO */}
      <section className="relative overflow-hidden bg-white py-24">
        <div
          className="absolute top-0 left-0 w-full h-2"
        />

        <div className="absolute right-0 top-0 w-96 h-96 bg-blue-100 rounded-full blur-3xl opacity-40"></div>
        <div className="absolute left-0 bottom-0 w-96 h-96 bg-red-100 rounded-full blur-3xl opacity-40"></div>

        <div className="w-11/12 xl:w-4/5 mx-auto grid grid-cols-2 gap-14 items-center md:grid-cols-1 relative z-10">

          {/* TEXTO */}
          <div>
            <span
              className="uppercase tracking-[5px] text-sm font-semibold"
              style={{ color: COLORS.blue }}
            >
              Carrera Profesional
            </span>

            <h1
              className="text-6xl lg:text-5xl md:text-4xl font-bold mt-5 leading-tight"
              style={{ color: COLORS.red }}
            >
              Aviación Comercial
            </h1>

            <div
              className="w-28 h-1 rounded-full my-7"
              style={{ backgroundColor: COLORS.yellow }}
            ></div>

            <p className="text-lg text-slate-600 leading-relaxed max-w-xl">
              Prepárate para trabajar en aerolíneas, aeropuertos y empresas de
              transporte con formación profesional de alto nivel.
            </p>

            <div className="flex flex-wrap gap-4 mt-8">
              <Badge icon={<FaClock />} text="24 Meses" />
              <Badge icon={<FaAward />} text="Título Técnico" />
              <Badge icon={<FaBriefcase />} text="Alta Demanda Laboral" />
            </div>

            <div className="flex flex-wrap gap-4 mt-10">
              <a
                href="https://wa.me/51967575397"
                target="_blank"
                rel="noopener noreferrer"
                className="px-7 py-4 rounded-xl text-white font-semibold shadow-xl hover:scale-105 transition flex items-center gap-3"
                style={{ backgroundColor: "#25D366" }}
              >
                <FaWhatsapp />
                Solicitar Información
              </a>

              <button
                onClick={() => setOpenVideo(true)}
                className="px-7 py-4 rounded-xl border border-slate-300 bg-white hover:bg-slate-100 transition font-semibold flex items-center gap-3"
              >
                <FaPlayCircle />
                Ver Programa
              </button>
            </div>
          </div>

          {/* IMAGEN */}
          <div className="relative">
            <img
              src={chef}
              alt="Aviación Comercial"
              className="rounded-[32px] shadow-2xl h-[580px] w-full object-cover"
            />

            <div className="absolute -bottom-7 -left-7 bg-white rounded-2xl p-5 shadow-2xl border w-72">
              <div className="flex items-center gap-4">
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center text-white text-xl"
                  style={{ backgroundColor: COLORS.red }}
                >
                  <FaPlane />
                </div>

                <div>
                  <h4 className="font-bold text-slate-800">
                    Formación Aeronáutica
                  </h4>
                  <p className="text-sm text-slate-500">
                    Counter + Cabina + Operaciones
                  </p>
                </div>
              </div>
            </div>

            <div className="absolute top-6 right-6 bg-white/90 backdrop-blur-md px-5 py-4 rounded-2xl shadow-xl">
              <p className="text-2xl font-bold" style={{ color: COLORS.blue }}>
                IATA
              </p>
              <p className="text-sm text-slate-500">
                Formación Internacional
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFICIOS */}
      <section className="py-24 bg-slate-50">
        <div className="w-11/12 xl:w-4/5 mx-auto">

          <div className="text-center max-w-4xl mx-auto mb-14">
            <span
              className="uppercase tracking-[4px] text-sm font-semibold"
              style={{ color: COLORS.blue }}
            >
              Ventajas
            </span>

            <h2 className="text-5xl font-bold mt-4 text-slate-900">
              ¿Por qué estudiar Aviación?
            </h2>
          </div>

          <div className="grid grid-cols-3 gap-7 md:grid-cols-1">

            <InteractiveCard
              icon={<FaPlane />}
              title="Seguridad a Bordo"
              text="Capacitación en procedimientos y protocolos aeronáuticos."
            />

            <InteractiveCard
              icon={<FaGlobeAmericas />}
              title="Geografía IATA"
              text="Conocimiento global para operaciones internacionales."
            />

            <InteractiveCard
              icon={<FaBriefcase />}
              title="Alta Empleabilidad"
              text="Acceso a oportunidades en múltiples sectores."
            />

          </div>
        </div>
      </section>

      {/* PLAN DE ESTUDIO */}
      <section className="py-24 bg-white">
        <div className="w-11/12 xl:w-4/5 mx-auto">

          <div className="text-center mb-16">
            <span
              className="uppercase tracking-[4px] text-sm font-semibold"
              style={{ color: COLORS.blue }}
            >
              Formación Académica
            </span>

            <h2
              className="text-5xl font-bold mt-4"
              style={{ color: COLORS.red }}
            >
              Lo que aprenderás
            </h2>
          </div>

          <div className="grid grid-cols-2 gap-6 md:grid-cols-1">
            <Feature text="Tarifa y boletaje aéreo." />
            <Feature text="Técnicas de counter." />
            <Feature text="Lost and Found." />
            <Feature text="Tripulación de cabina." />
            <Feature text="Primeros auxilios y seguridad." />
            <Feature text="Supervivencia: mar, selva y desierto." />
          </div>
        </div>
      </section>

      {/* DOCENTES */}
      <section className="py-24 bg-slate-50">
        <div className="w-11/12 xl:w-4/5 mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-5xl font-bold text-slate-900">
              Docentes Especialistas
            </h2>
          </div>

          <TeamSections />
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 bg-white">
        <div className="w-11/12 xl:w-4/5 mx-auto max-w-4xl">

          <div className="text-center mb-14">
            <h2 className="text-5xl font-bold text-slate-900">
              Preguntas Frecuentes
            </h2>
          </div>

          <div className="space-y-4">
            {faqs.map((item, index) => (
              <div
                key={index}
                className="border rounded-2xl overflow-hidden bg-slate-50"
              >
                <button
                  onClick={() =>
                    setOpenFaq(openFaq === index ? -1 : index)
                  }
                  className="w-full px-6 py-5 text-left flex justify-between items-center font-semibold"
                >
                  {item.q}

                  <FaChevronDown
                    className={`transition ${
                      openFaq === index ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {openFaq === index && (
                  <div className="px-6 pb-6 text-slate-600 leading-relaxed">
                    {item.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-slate-50">
        <div className="w-11/12 xl:w-4/5 mx-auto">

          <div
            className="rounded-[32px] p-14 text-white shadow-2xl text-center"
            style={{
              background: `linear-gradient(135deg, ${COLORS.blue}, #0067F5)`,
            }}
          >
            <h2 className="text-5xl font-bold">
              Tu futuro despega hoy
            </h2>

            <p className="mt-5 text-blue-100 text-lg max-w-2xl mx-auto">
              Solicita información sobre horarios, matrícula y beneficios.
            </p>

            <a
              href="https://wa.me/51967575397"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex mt-8 px-8 py-4 bg-white text-slate-900 rounded-xl font-bold items-center gap-3 hover:scale-105 transition"
            >
              Contactar Ahora
              <FaArrowRight />
            </a>
          </div>
        </div>
      </section>
{/* MODAL VIDEO */}
{openVideo && (
  <div className="fixed inset-0 bg-black/70 z-[9999] flex items-center justify-center px-4">

    <div className="bg-white rounded-3xl shadow-2xl w-full max-w-5xl overflow-hidden relative">

      <button
        onClick={() => setOpenVideo(false)}
        className="absolute top-4 right-4 z-20 w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center"
      >
        <FaTimes />
      </button>

      <div className="p-6 border-b">
        <h3 className="text-2xl font-bold text-slate-800">
          Programa Aviacion Comercial
        </h3>
      </div>

      <div className="w-full h-[70vh]">
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/y01d0zMeklc?autoplay=1&rel=0"
          title="Video Chef"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>

    </div>
  </div>
)}
    </div>
  );
};

export default AviacionComercialCevatur;

/* COMPONENTES */

const Badge = ({ icon, text }) => (
  <div className="bg-slate-100 px-5 py-3 rounded-xl flex items-center gap-3 text-sm font-semibold">
    <span style={{ color: COLORS.blue }}>{icon}</span>
    {text}
  </div>
);

const InteractiveCard = ({ icon, title, text }) => (
  <div className="group bg-white p-8 rounded-3xl shadow-md hover:shadow-2xl transition duration-500 hover:-translate-y-2 cursor-pointer">
    <div
      className="w-16 h-16 rounded-2xl flex items-center justify-center text-2xl text-white mb-6"
      style={{ backgroundColor: COLORS.red }}
    >
      {icon}
    </div>

    <h3 className="text-2xl font-bold text-slate-800">
      {title}
    </h3>

    <p className="text-slate-600 mt-4 leading-relaxed">
      {text}
    </p>
  </div>
);

const Feature = ({ text }) => (
  <div className="bg-slate-50 border border-slate-200 rounded-2xl p-6 flex gap-4 hover:shadow-lg transition">
    <div
      className="w-10 h-10 rounded-xl text-white flex items-center justify-center"
      style={{ backgroundColor: COLORS.red }}
    >
      <FaCheckCircle />
    </div>

    <p className="font-medium text-slate-700">
      {text}
    </p>
  </div>
);